import React from 'react';
import { Link } from 'react-router-dom';
import { Target } from 'lucide-react';

export default function CaptureSupportPage() {
  return (
    <div className="page-container">
      <section className="page-header section-dark">
        <div className="section-content">
          <div style={{ textAlign: 'center', maxWidth: '900px', margin: '0 auto' }}>
            <Target size={56} style={{ color: 'var(--gold-primary)', marginBottom: '24px' }} />
            <h1 style={{ fontSize: '48px', marginBottom: '24px' }}>Capture Support</h1>
            <p style={{ fontSize: '20px', color: 'var(--text-secondary)' }}>
              Strategic capture planning from opportunity identification through submission, ensuring your team is positioned to win before the RFP drops.
            </p>
          </div>
        </div>
      </section>

      <section className="section section-light">
        <div className="section-content">
          <div style={{ textAlign: 'center' }}>
            <h2 style={{ marginBottom: '24px' }}>Discuss Your Capture Strategy</h2>
            <Link to="/contact" className="btn-primary">Contact Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
